"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PickupPointsListSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _DeliveryBoxSkeleton = require("./DeliveryBoxSkeleton");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  marginBottom: theme.spacing(1),
  paddingTop: theme.spacing(2)
}));
const ResultsHeader = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(2)
}));
const PickupPointsListSkeleton = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    "data-testid": getTestId(_models.TestId.SkeletonPickupPointsList),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(ResultsHeader, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
        animation: "wave",
        variant: "text",
        width: 80,
        height: 32
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
        animation: "wave",
        variant: "text",
        width: 80,
        height: 28
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeliveryBoxSkeleton.DeliveryBoxSkeleton, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeliveryBoxSkeleton.DeliveryBoxSkeleton, {})]
  });
};
exports.PickupPointsListSkeleton = PickupPointsListSkeleton;